import React from "react"
import PropTypes from "prop-types"
import RoundedCheckBox from "../../../../ui-components/RoundedCheckBox"

import style from "./index.module.sass"

export default function FilterRow(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { name, label, selected, onSelect } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div
      className={`row ${style.filterRow}`}
      onClick={onSelect.bind(this, name)}
    >
      <div className="col-xs-10">{label}</div>
      <div className="col-xs-2">
        <RoundedCheckBox checked={selected} readOnly/>
      </div>
    </div>
  )
}

FilterRow.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  name: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
}
